import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { cropIconUrl } from '../../../features/planning/crop-icons';

@Component({
  selector: 'app-crop-icon',
  standalone: true,
  template: `@if (iconUrl(); as url) {
    <img [src]="url" alt="" aria-hidden="true" width="24" height="24"
         style="display:inline-block;width:1.5em;height:1.5em;object-fit:contain;vertical-align:middle;margin-right:0.35em" loading="lazy" />
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CropIcon {
  readonly crop = input<string | null | undefined>(null);
  readonly iconUrl = computed(() => cropIconUrl(this.crop()));
}
